import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import testScore from './test-score';
import './QuestionList.scss'
import Question from "./Question";
import Checkbox from "../../../shared/forms/Checkbox";
import classNames from 'classnames';
import LoadingButton from '../../../shared/ui/LoadingButton';

import notificationsActionCreators from "../../store/notifications/action-creators";
import testsActionCreators from "../../store/tests/action-creators";

function mapStateToProps(state) {
  return {
    userContext: state.common.userContext,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    sendNotification(notification) {
      return dispatch(notificationsActionCreators.addNotification(notification));
    },
    retryTest(form) {
      return dispatch(testsActionCreators.retryTest(form));
    },
    finishTest(form) {
      return dispatch(testsActionCreators.finishTest(form));
    }
  };
}

class QuestionList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      answers: this.props.answers || {},
      showResults: this.props.status === 'completed',
      score: 0,
      minutes: this.props.testTemplate.duration,
      seconds: 0,
      subjectiveQuestionsScore: {}
    }
  }

  componentDidMount() {
    if (this.props.testObj) {
      const testEndTimestamp = moment(this.props.testObj.started_at).add(this.state.minutes, 'minutes');
      const milisecondsDuration = moment.duration(testEndTimestamp.diff(moment())).asMilliseconds();

      const secondsDuration = milisecondsDuration  / 1000;
      const remainingMinutes = secondsDuration / 60;
      const remainingSeconds = secondsDuration % 60;

      this.setState({
        minutes: Math.floor(remainingMinutes),
        seconds: Math.floor(remainingSeconds)
      });

      if (milisecondsDuration > 0) {
        this.finishTestInterval = setInterval(() => {
          clearInterval(this.finishTestInterval);
          this.submitTest(true);
        }, milisecondsDuration);

        this.remainingTime = setInterval(() => {
          const { seconds, minutes } = this.state
          if (seconds > 0) {
            this.setState(({ seconds }) => ({
              seconds: seconds - 1
            }))
          }
          if (seconds === 0) {
            if (minutes === 0) {
              clearInterval(this.remainingTime)
            } else {
              this.setState(({ minutes }) => ({
                minutes: minutes - 1,
                seconds: 59
              }))
            }
          }
        }, 1000);
      }
    }
  }

  componentWillUnmount() {
    clearInterval(this.finishTestInterval);
    clearInterval(this.remainingTime);
  }

  get overAllScore() {
    if (this.props.score != null) {
      return this.props.score
    }

    if (!this.props.questions) {
      return 0
    }
    return testScore(this.props.questions, this.state.answers);

  }

  get isPassed() {
    return (parseInt(this.props.passingScore) <= parseInt(this.overAllScore) || this.props.passed )
  }

  get retryTest() {
    return this.props.testObj ? this.props.testObj.finished_at : false;
  }

  get minutes() {
    return this.state.minutes > 9 ? this.state.minutes : '0' + this.state.minutes;
  }

  get seconds() {
    return this.state.seconds > 9 ? this.state.seconds : '0' + this.state.seconds;
  }

  get hasSubjectiveQuestion() {
    const subjectiveQuestions = this.props.questions.filter(question => {
      return question.isSubjective
    }, 0);

    return subjectiveQuestions.length > 0;
  }

  gradeAnswer(question, grade) {
    const answers = this.state.answers[question.id] || {answers: []};
    const grades = [...(answers.grades || (answers.correct === true || answers.correct === false ? [answers.correct] : []))];
    grades[grade.lineIndex] = grade.grade;
    const updatedAnswers = {...answers, grades};

    this.props.onGradeAnswer({question, ...grade})
      .then(() => {
        this.updateAnswer(question, updatedAnswers);
      })
  }

  isQuestionAnswered(question) {
    const answer = this.state.answers[question.id];
    if (question.isSubjective) {
      return true;
    }

    return answer && answer.answers && answer.answers.length > 0;
  }

  updateAnswer(question, answers) {
    this.setState({
      answers: {
        ...this.state.answers,
        [question.id]: answers
      }
    })
  }

  setShowResults(e) {
    this.setState({
      showResults: e.target.checked
    })
  }

  submitTest(enablePartiaAnswers) {
    if (!this.props.questions.every(question => this.isQuestionAnswered(question)) && !enablePartiaAnswers) {
      this.props.sendNotification({
        id: Date.now(),
        type: 'error',
        content: 'You have to fill all of the questions'
      })
    } else {
      this.props.onSubmit({
        answers: this.state.answers
      }).then(() => {
        this.props.sendNotification({
          id: Date.now(),
          type: 'success',
          content: 'You have successfully submitted the test'
        })

        const form = {
          id: this.props.testObj.id,
          finished_at: (new Date).toISOString()
        };
        this.props.finishTest(form);
      })
    }
  }

  saveAnswers() {
    this.props.onSubmit({
      answers: this.state.answers
    }).then((data) => {
      this.props.sendNotification({
        id: Date.now(),
        type: 'success',
        content: 'You have successfully saved the answers'
      })
    })
  }

  onRetryTest(testId) {
    const form = {
      id: testId,
      started_at: (new Date).toISOString()
    };

    this.props.retryTest(form).then((newTest) => {
      this.props.onTestRetried(newTest);
    });
  }

  onFinishTest(testId) {
    const form = {
      id: testId,
    };

    this.props.onFinishTest(form)
  }

  onUpdateScore(score, question) {
    let subjectiveQuestionsScore = this.state.subjectiveQuestionsScore;
    subjectiveQuestionsScore[question.id] = score;

    this.setState({
      subjectiveQuestionsScore
    });
  }

  saveScore() {
    console.log('this.state.subjectiveQuestionsScore', this.state.subjectiveQuestionsScore)
  }

  get needsGrading() {
    return this.props.questions.filter(q => {
      if (q.isSubjective) {
        const answer = this.state.answers[q.id] || {};
        const grades = answer.grades || (answer.correct === true || answer.correct === false ? [answer.correct] : []);
        const answerLines = Math.max(1, parseInt(q.answerLines, 10) || 1);
        return Array.from({length: answerLines}, (_, index) => {
          const value = answer.answers && answer.answers[index];
          return value && value.trim() ? grades[index] : false;
        }).some(grade => grade !== true && grade !== false);
      }
      if (!this.state.answers[q.id]) {
        return false;
      }
      return !(this.state.answers[q.id].correct === true || this.state.answers[q.id].correct === false);
    }).length > 0;
  }

  render() {

    return (
      <div className="question-list">
        <div className={classNames("question-status")}>
          {this.props.userContext.hasScope(['fto']) &&
          <span style={{fontWeight: 900}}>
              The correct answers are marked with green
            </span>
          }
          {this.props.canEdit && !this.props.userContext.hasScope(['fto']) && (
            <Checkbox label="Simulate test results" checked={this.state.showResults}
                      onChange={(e) => this.setShowResults(e)}/>
          )}
          {this.props.status === 'started' && !!this.props.testTemplate.duration ? (
            <span className="time-remaining">You have {this.minutes}:{this.seconds} minutes to finish the test</span>
          ) : null}

          {this.props.status === 'started' ? (
            <div className="btns-container">
              <Fragment>
                <div className="btn-container left">
                  <button className="button small primary" onClick={() => this.saveAnswers()}>
                    <i className="fa fa-save"/>
                    Save
                  </button>
                </div>

                <div className="btn-container">
                  <button className="button small primary finish-test-btn" onClick={() => this.submitTest(false)}>
                    FINISH TEST
                  </button>
                </div>
              </Fragment>
            </div>
          ) : null}

          {this.props.canEdit && (this.props.testObj && this.props.testObj.finished_at || !this.props.testObj) && this.state.showResults && (
            <div>
              {this.props.status === 'waiting' ? (
                <div className="score-container">
                  <span className="needs-grading">WAITING FOR GRADE</span>
                </div>
              ) : (
                <div className={classNames("score-container", {
                  passed: this.state.showResults && this.isPassed,
                  failed: this.state.showResults && !this.isPassed,
                })}>
                  {this.overAllScore}% {(parseInt(this.props.passingScore) <= parseInt(this.overAllScore) || this.props.passed ) ?
                  <span className="correct">PASSED</span> : <span className="incorrect">FAILED</span>}
                </div>
              )}
            </div>
          )}

          {!this.props.canEdit && (this.props.testObj && this.props.testObj.finished_at || !this.props.testObj) &&
          <div className="results-container">
            {this.props.status === 'waiting' ? (
              <div className="score-container">
                <span className="needs-grading">WAITING FOR GRADE</span>
              </div>
            ) : (
              <div className={classNames("score-container", {
                passed: this.state.showResults && this.isPassed,
                failed: this.state.showResults && !this.isPassed,
              })}>
                {this.overAllScore}% {(this.props.passingScore <= this.overAllScore || this.props.passed) ?
                <span className="correct">PASSED</span> : <span className="incorrect">FAILED</span>}
              </div>
            )}


            <div>
              {this.props.questions.map(question => (
                <Question
                  key={question.id}
                  question={question}
                  answers={this.state.answers[question.id]}
                  canEdit={false}
                  canAnswer={false}
                    testEnded={true}
                    showAnswer={this.props.userContext.hasScope(['fto', 'ftoc']) ? true : this.props.testTemplate.allowTakerViewResults}
                    onGrade={(answers) => this.gradeAnswer(question, answers)}
                    updateScore={this.onUpdateScore.bind(this)}
                  />
                ))}
              </div>
            </div>
          }
        </div>
        {!this.retryTest && this.props.questions.map(question => (
          <Question
            key={question.id}
            question={question}
            answers={this.state.answers[question.id]}
            canEdit={this.props.canEdit}
            canAnswer={this.props.status !== 'completed'}
            showAnswer={this.props.showAnswer ? this.props.showAnswer : this.state.showResults}
            allowTakerChangeAnswerIfCorrectDisplayed={this.props.testTemplate.allowTakerChangeAnswerIfCorrectDisplayed}
            allowTakerViewCorrectAnswer={this.props.testTemplate.allowTakerViewCorrectAnswer}
            onAnswer={(answers) => this.updateAnswer(question, answers)}
            onEdit={() => this.props.onEdit(question)}
            onDelete={() => this.props.onDelete(question)}
            updateScore={this.onUpdateScore.bind(this)}
          />
        ))}
        {!this.retryTest && !this.props.canEdit &&
        <div className="submit-bottom-container">
          <button className="button small primary" onClick={() => this.submitTest(false)}>
            FINISH TEST
          </button>
        </div>
        }

        {this.hasSubjectiveQuestion && this.props.testObj && this.props.testObj.finished_at && this.props.userContext.hasScope(['fto']) && (
          <div className="save-score-container">
            <button className="button small secondary" onClick={() => this.saveScore()}>
              Save Score
            </button>
          </div>
        )}

        {this.props.userContext.hasScope('oit') && this.props.status === 'completed' && this.props.testTemplate.attempts > 1 && !this.props.passed && this.retryTest &&
        <div className="retry-btn">
          <LoadingButton
            primary
            isLoading={this.state.isLoading}
            text="Retry Test"
            onClick={() => this.onRetryTest(this.props.testObj.id)}
          />
        </div>
        }
        {this.needsGrading && this.props.status === 'waiting' && !this.props.userContext.hasScope('oit') &&
        <div className="retry-btn">
          Please grade the test before you can finish
        </div>
        }
        {!this.needsGrading && this.props.status === 'waiting' &&
        <div className="retry-btn">
          <LoadingButton
            primary
            isLoading={this.state.isLoading}
            text="Finish Test"
            onClick={() => this.onFinishTest(this.props.testObj.id)}
          />
        </div>
        }
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionList);
